// The online card games in the browser, one file each (owner 2026-10-29: "generalizacja logiki i vertical slices"):
// common.ts holds what they share (the frames, the hidden cards, the seat names, the turn clock); each game's file
// makes a store with its offline store's interface, fed by the server. A new game: its file here and a line below
// (with its server module in server/ws/cards/, .ai/multiplayer-protocol-v2.md "Card games").
import type { OnlineCardGame, OnlineDeps } from './common';
import { createOnlineHearts } from './hearts';
import { createOnlineMakao } from './makao';
import { createOnline358 } from './three-five-eight';
import { createOnlineThousand } from './thousand';

export type { CardEndFrame, CardStart, CardStateFrame, OnlineCardGame, OnlineDeps } from './common';

/** game id -> its online table. */
export function createOnlineCards(deps: OnlineDeps): Record<string, OnlineCardGame> {
  return Object.fromEntries([createOnlineMakao(deps), createOnlineHearts(deps), createOnlineThousand(deps), createOnline358(deps)].map((g) => [g.game, g]));
}
